import { Store } from 'src/store/index';

const getAvailableFormats = (store: Store) => store.format.availableFormats;

export default getAvailableFormats;
